export function formatTermDisplayValue(term: any) {
  if (term.toLocaleLowerCase().startsWith('week')) {
    return 'Week ' + term.substring(4);
  }
  return term;
}
